import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Movie from "../../../assets/movies/slide2.mp4";
import { Heading } from "@/components/ui/heading";
import Paths from "../../../constants/Paths";
import { Button } from "@/components/ui/button";

const Slide2 = ({ sliderRef }) => {
    const navigate = useNavigate();
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (video) {
            const handleEnded = () => {
                if (sliderRef.current) {
                    sliderRef.current.slickNext();
                }
            };
            video.addEventListener("ended", handleEnded);
            return () => {
                video.removeEventListener("ended", handleEnded);
            };
        }
    }, [sliderRef]);

    return (
        <div className="slide-2">
            <div className="generic-container">
                <Heading level={1} className='hero-title'>
                    Take advantage
                </Heading>
                <Heading level={2} className='hero-subtitle'>
                    of our training tools
                </Heading>
                <Button onClick={() => navigate(Paths.TRAINING)} className="big-button white-variant">Training</Button>
                <video ref={videoRef} autoPlay className="background-video" data-mode="center" data-keepplaying="1" preload="auto" playsInline muted>
                    <source src={Movie} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>
        </div>
    );
}

export default Slide2;